<template>
    <div class="price-breakdown-row-group" :class="expanded && 'expanded'">
        <button
            class="price-breakdown-row-button"
            type="button"
            @click="setIsExpanded(!expanded)">
            <span class="price-breakdown-row-button-label">
                {{ item.items.length }}
                {{ getTitle(item.type, item.items.length) }}
                <Icon
                    class="ml-2"
                    :type="'Chevron'"
                    :rotate="expanded ? 180 : 0"
                    :color="'black'" />
            </span>
            <span v-if="item.totalPrice">{{ getMoneyObjectAsString(item.totalPrice) }}</span>
        </button>

        <TransitionExpand>
            <div v-if="expanded" class="w-100">
                <div class="price-breakdown-row-group-inner">
                    <Row
                        v-for="(row, index) in item.items"
                        :key="row.label + '-' + index"
                        :mobile="mobile"
                        :item="{ ...row, title: undefined }" />
                </div>
            </div>
        </TransitionExpand>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, PropType } from 'vue';
    import { ProductRow } from '../types';
    import { getTitle } from '../map/index';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import Icon from '@ui/components/Icon/Icon.vue';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';
    import Row from './Row.vue';

    export default defineComponent({
        name: 'RowGroup',
        components: { Row, Icon, TransitionExpand },
        props: {
            item: {
                type: Object as PropType<ProductRow>,
                required: true,
            },
            mobile: {
                type: Boolean,
            },
        },
        methods: { getMoneyObjectAsString },
        setup() {
            const expanded = ref<boolean>(false);

            const setIsExpanded = (visible: boolean) => {
                expanded.value = visible;
            };

            return {
                getTitle,
                setIsExpanded,
                expanded,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'PriceBreakdown';
</style>
